import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Home.css';
import steinwayPiano from './path/to/steinwayPiano.jpg';
import uprightPiano from './path/to/uprightPiano.jpg';
import Modal from 'react-modal';
import Login from './Login';
import Register from './Register';
import { AuthContext } from '../context/AuthContext';

const Home = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isLoginMode, setIsLoginMode] = useState(true);
  const [redirectUrl, setRedirectUrl] = useState(''); // State to store where the user wanted to go
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleReservationClick = (room) => {
    const token = localStorage.getItem('token');
    const bookingUrl = `/booking-calendar?salle=${room}`;
    
    if (!token) {
      setRedirectUrl(bookingUrl); // Set the URL to redirect after login
      setModalIsOpen(true);
    } else {
      navigate(bookingUrl); // Redirect to booking calendar if logged in
    }
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  return (
    <div className="home-container">
      <header className="hero-header">
        <h1>Location de salles de piano à Paris</h1>
      </header>

      <section className="intro-section">
        <p className="intro-text">
          Bienvenue à l'Auditorium du Marais, situé au cœur de Paris.
	      Réservez nos salles pour vos répétitions, concerts, et auditions.
        </p>
      </section>

      <section className="rooms-section">
        <div className="room-card">
          <img src={steinwayPiano} alt="Piano Steinway dans la grande salle" className="room-image" />
          <h3>Grande Salle</h3>
          <div className="room-actions">
            <Link to="/rooms#grande-salle">
              <button className="cta-button info-button">Plus d'infos</button>
            </Link>
            <button className="cta-button reserve-button" onClick={() => handleReservationClick('grande')}>Réserver</button>
          </div>
        </div>

        <div className="room-card">
          <img src={uprightPiano} alt="Piano droit dans la petite salle" className="room-image" />
          <h3>Petite Salle</h3>
          <div className="room-actions">
            <Link to="/rooms#petite-salle">
              <button className="cta-button info-button">Plus d'infos</button>
            </Link>
            <button className="cta-button reserve-button" onClick={() => handleReservationClick('petite')}>Réserver</button>
          </div>
        </div>
      </section>

      {/* Modal for login or register */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Login or Register"
        className="auth-modal"
		 overlayClassName="modal-overlay"
        ariaHideApp={false}
      >
		{isLoginMode ? (
		  <>
		    <Login onSuccess={() => { closeModal(); navigate(redirectUrl); }} />
		    {/* Remove or comment out this line below to avoid duplicate text */}
		    {/* <p>Pas encore inscrit ? <button onClick={() => setIsLoginMode(false)} className="switch-button">Créer un compte</button></p> */}
		  </>
		) : (
		  <>
		    <Register onSuccess={() => { closeModal(); navigate(redirectUrl); }} />
		    <p>Déjà un compte ? <button onClick={() => setIsLoginMode(true)} className="switch-button">Se connecter</button></p>
		  </>
		)}
      </Modal>
    </div>
  );
};

export default Home;